<script>
	import { scaleLinear } from 'd3';
    import dbData from "../../Stores/utilityDBStore.js";
	import { correlationDataPoints, correlationScore } from '../../scripts/alfxCorrelation.js';
    import { firstItemWithValueForKey } from '../../scripts/wpn2Model.js';
    // Using D3 in svelte: https://www.connorrothschild.com/post/svelte-and-d3
    // Intro:  https://dev.to/learners/series-intro-data-visualization-with-svelte-and-d3-4c07
    // Svelte bar chart: https://svelte.dev/repl/8722c32f4e1a44a98e3a3fc8a095b2d7?version=3.5.3
    // Svelte line graph: https://svelte.dev/repl/8262eb73a08f48adba8e0b706c1a939f?version=3.22.1

	const padding = { top: 20, right: 15, bottom: 20, left: 25 };
    export let corrItem;
    export let locationItem;
    let points;
    let distances;
    let width = 400;
	let height = 300;
	let svg_element;

    $: points = correlationDataPoints(corrItem);
    $: distances = hydrantDistancesText();
    $: colors = hydrantColors();

    $: xScale = scaleLinear()
		.domain([minX, maxX])
		.range([padding.left, width - padding.right]);

    $: yScale = scaleLinear()
		.domain([-1, 1])
		.range([height - padding.bottom, padding.top]);

    $: minX = (points.length > 0) ? points[0].x : 0;
	$: maxX = (points.length > 0) ? points[points.length - 1].x : 0;
	$: path = `M${points.map(p => `${xScale(p.x)},${yScale(p.y)}`).join('L')}`;

    function hydrantDistancesText() {
        const pathBreadcrumbs = corrItem?.['path_breadcrumbs'] ?? {};
        const hydrantUuids = Object.keys(pathBreadcrumbs);
        let distancesText = ["", ""];
        for (let i = 0; i < hydrantUuids.length; i++) {
            const uuid = hydrantUuids[i];
            const hydrant = firstItemWithValueForKey('uuid', uuid, $dbData.all['FixedAsset']);
            const hName = hydrant['name'] ?? "";
            const distance = pathBreadcrumbs[uuid]['hydrant_lag_distance'] ?? -1.0;
            if (typeof hName === 'string' && hName.trim() !== '' && distance >= 0.0) {
                distancesText[i] = hName + ": " + (distance * 3.28084).toFixed(1) + " ft";
            }
        }
        return distancesText;
    }

    function hydrantColors() {
        const hydrantPaths = locationItem?.['hydrant_paths'] ?? {};
        const hydrantUuids = Object.keys(hydrantPaths);
        let colors = ["#b2b2b2", "#b2b2b2"];
        for (let i = 0; i < hydrantUuids.length; i++) {
            const uuid = hydrantUuids[i];
            const color = hydrantPaths[uuid]['color'] ?? "#b2b2b2";
            colors[i] = color;
        }
        return colors;
    }
</script>

<div class="detail-section">
    <div class="sensor-data-title">{"Correlation (" + correlationScore(corrItem).toFixed(0) + ")"}</div>
    {#if points.length > 0}
        <div class="chart" bind:clientWidth={width} bind:clientHeight={height}>
            <svg bind:this={svg_element} transform="translate(0, 0)">
                <g>
                    <path class="path-line" d={path}></path>
                </g>
            </svg>			
        </div>
        <div class="distances-container">
            <div class="side-by-side">
                <!-- Add distances from corrItem -->
                <p id="ls1-dist" style="--border-color: {colors[0]}">{distances[0]}</p>
                <p id="ls2-dist" style="--border-color: {colors[1]}">{distances[1]}</p>
            </div>
        </div>
    {:else}
        <div class="sensor-data-unavailable">
            <p>Correlation data unavailable</p>
        </div>
    {/if}
</div>

<style>
    .distances-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .side-by-side {
        display: flex;
        gap: 20px;
    }
    #ls1-dist {
        border-bottom: 2px solid var(--border-color);  /* #ff4b4b; */
        padding-bottom: 4px;
        margin-right: 16px;
        font-size: 0.9rem;
    }
    #ls2-dist {
        border-bottom: 2px solid var(--border-color);  /* #ffcc00; */
        padding-bottom: 4px;
        margin-left: 16px;
        font-size: 0.9rem;
    }
	.chart {
		width: 100%;
		/* max-width: 500px; */
		margin: 16px auto 0 auto;
	}
    svg {
		width: 100%;
		height: 100%;
	}
    g {
        transform: scale(1, 3);
        transform-origin: 0px 32px;
    }
	/* #corr-score {
		text-align: center;
	} */
</style>